import React, { Component } from 'react';
import Row  from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { observer } from 'mobx-react'
import SensorMap from '../../components/sensormap/SensorMap'
import './Locations.css';

export default observer(class Locations extends Component {

  render() {

    return (
      <Row>
        <Col xs={12}>
          <h1>Communities</h1>
        </Col>

        <Col xs={12}>
          <SensorMap />
        </Col>
      </Row>
    );
  }


})



// WEBPACK FOOTER //
// ./src/routes/locations/Locations.js